import { render, staticRenderFns } from "./AiAssistancePage.vue?vue&type=template&id=031f55a8&scoped=true"
import script from "./AiAssistancePage.vue?vue&type=script&lang=js"
export * from "./AiAssistancePage.vue?vue&type=script&lang=js"
import style0 from "./AiAssistancePage.vue?vue&type=style&index=0&id=031f55a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031f55a8",
  null
  
)

export default component.exports